/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import React from "react";

export interface AnimatedCompletionCheckProps {
    size?: number;
    color?: string;
    ringAnimationDuration?: string;
    checkAnimationStartDelay?: string;
    checkAnimationDuration?: string;
}

/**
 * Based on a checkbox from https://codepen.io/elevaunt/pen/JYRBzJ
 * @param props
 * @constructor
 */
const AnimatedCompletionCheck = (props: AnimatedCompletionCheckProps) => {
    const {
        color = "#388e3c",
        ringAnimationDuration = "0.9s",
        checkAnimationStartDelay = "0.35s",
        checkAnimationDuration = "0.35s",
        size = 32,
    } = props;

    const checkCSS = `        
        .path {
            stroke-dasharray: 1000;
            stroke-dashoffset: 0;
            &.circle {
                -webkit-animation: dash ${ringAnimationDuration} ease-in-out;
                animation: dash ${ringAnimationDuration} ease-in-out;
            }
            &.line {
                stroke-dashoffset: 1000;
                -webkit-animation: dash ${checkAnimationDuration} ${checkAnimationStartDelay} ease-in-out forwards;
                animation: dash ${checkAnimationDuration} ${checkAnimationStartDelay} ease-in-out forwards;
            }
            &.check {
                stroke-dashoffset: -100;
                -webkit-animation: dash-check ${checkAnimationDuration} ${checkAnimationStartDelay} ease-in-out forwards;
                animation: dash-check ${checkAnimationDuration} ${checkAnimationStartDelay} ease-in-out forwards;
            }
        }

        @-webkit-keyframes dash {
            0% {
                stroke-dashoffset: 1000;
            }
            100% {
                stroke-dashoffset: 0;
            }
        }

        @keyframes dash {
            0% {
                stroke-dashoffset: 1000;
            }
            100% {
                stroke-dashoffset: 0;
            }
        }
        
        @-webkit-keyframes dash-check {
            0% {
                stroke-dashoffset: -100;
            }
            100% {
                stroke-dashoffset: 900;
            }
        }
        
        @keyframes dash-check {
            0% {
                stroke-dashoffset: -100;
            }
            100% {
                stroke-dashoffset: 900;
            }
        }
    `;

    return (
        <div>
            <style>{checkCSS}</style>

            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" width={size} height={size}>
                <circle
                    className="path circle"
                    fill="none"
                    stroke={color}
                    stroke-width="6"
                    stroke-miterlimit="10"
                    cx="65.1"
                    cy="65.1"
                    r="62.1"
                />

                <polyline
                    className="path check"
                    fill="none"
                    stroke={color}
                    stroke-width="6"
                    stroke-linecap="round"
                    stroke-miterlimit="10"
                    points="100.2,40.2 51.5,88.8 29.8,67.5 "
                />
            </svg>
        </div>
    );
};

export default AnimatedCompletionCheck;
